import emptyContentImageSmall from '@juvare/common-web-ui/assets/emptyContentImageSmall.svg';
import { PartialError } from '@juvare/common-web-ui/PartialError';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useCommonDataTableUiTranslation } from '../../hooks';
export function TableStatesContent({ rows, loading, error, }) {
    const { t } = useCommonDataTableUiTranslation();
    if (rows.length > 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        loading && error == null && (React.createElement(Box, { sx: {
                py: 16,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
            } },
            React.createElement(CircularProgress, { size: 54 }))),
        !loading && error == null && (React.createElement(Box, { sx: {
                py: 12,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
            } },
            React.createElement("img", { src: emptyContentImageSmall, alt: '' }),
            React.createElement(Typography, { variant: 'subtitle1' }, t('thereIsNoData')))),
        error != null && (React.createElement(Box, { sx: {
                py: 12,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 4,
            } },
            React.createElement(PartialError, { error: error })))));
}
